import { render, staticRenderFns } from "./ScarsTemplate.vue?vue&type=template&id=0d7bc283"
import script from "./ScarsTemplate.vue?vue&type=script&lang=js"
export * from "./ScarsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports